import { reportingPrisma as prisma, OrderStatus } from "client";

/**
 * Orders grouped by OrderStatus per day. Counts orders, not tickets.
 * Refund is tracked on PaymentStatus, not OrderStatus — not included here.
 */
export const getTicketsMonitorByStatus = async ({
  eventId,
  filters,
}: {
  eventId: string;
  filters: { [key: string]: string };
}) => {
  try {
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const stages = [
      {
        $match: {
          eventId: { $oid: eventId },
        },
      },
      {
        $addFields: {
          date: {
            $dateToString: {
              format: "%Y/%m/%d",
              date: "$createdAt",
              timezone: userTimeZone,
            },
          },
        },
      },
      {
        $group: {
          _id: {
            date: "$date",
          },
          Expired: {
            $sum: {
              $cond: {
                if: { $eq: ["$status", OrderStatus.EXPIRED] },
                then: 1,
                else: 0,
              },
            },
          },
          Canceled: {
            $sum: {
              $cond: {
                if: { $eq: ["$status", OrderStatus.CANCELED] },
                then: 1,
                else: 0,
              },
            },
          },
          Completed: {
            $sum: {
              $cond: {
                if: { $eq: ["$status", OrderStatus.COMPLETED] },
                then: 1,
                else: 0,
              },
            },
          },
          "In Progress": {
            $sum: {
              $cond: {
                if: { $eq: ["$status", OrderStatus.ON_GOING] },
                then: 1,
                else: 0,
              },
            },
          },
          // Refund: {
          //   $sum: {
          //     $cond: {
          //       if: { $eq: ["$status", OrderStatus.REFUND] },
          //       then: 1,
          //       else: 0,
          //     },
          //   },
          // },
        },
      },
      { $sort: { _id: 1 } },
    ];
    const result = await prisma.order.aggregateRaw({
      pipeline: [...stages],
    });
    return result || [];
  } catch (error) {
    console.error(error);
    throw error;
  }
};
